/**
 * Created by Ivan on 20.06.2026
 */

const LorysDerbyFinishWindow = Prefab.createWindow("lorys_derby", "lorys_derby_finish_window_prefab_json");
